var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("rb-textfield", {
    ref: "location",
    attrs: {
      id: _vm.id,
      type: "text",
      name: "location",
      "textfield-aria-label-error": _vm.textfieldAriaLabelError,
      "textfield-aria-label-default": _vm.textfieldAriaLabelDefault,
      label: _vm.label,
      validation: _vm.$v.location,
      error: _vm.error,
      disabled: _vm.disabled,
      iconclass: _vm.getIcon,
      helper: _vm.helper,
      "helper-error": _vm.helperError,
      required: _vm.required,
      initialvalue: _vm.initialLocation,
      autocomplete: "off",
    },
    on: {
      onIconClick: _vm.onSearchIconClick,
      onFocusOut: _vm.getValue,
      inputError: _vm.emitInvalidInput,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }